import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import logoImage from '@/images/HM_logo.png';
import '@/styles/Logo.css'; // Ensure the CSS is imported
/**
 * Logo component that displays the company logo.
 *
 * @param {LogoProps} props - The props for the component.
 * @returns {JSX.Element} The Logo component.
 */
export const Logo = ({ onChatpage = false }) => (_jsx("div", Object.assign({ className: `logo-container ${onChatpage ? 'header-logo' : 'fallback-logo'}` }, { children: _jsx("img", { src: logoImage, alt: "Company Logo" }) })));
